<div *ngIf="isReAcquistionRebrandingExpEnabled">
  <div class="tw-border tw-border-[#DCE8E5] tw-px-4 tw-py-6 tw-rounded-3 tw-bg-gradient-light-teal tw-font-body tw-shadow-z1 tw-mx-4">
    <span><img src="https://cdn.cureskin.com/app/img/warning_rounded.svg" /></span>
    <h1 class="tw-text-500 tw-font-bold tw-text-teal-600 tw-mt-2 tw-mb-2 tw-leading-5"><span class="tw-capitalize">{{ userFirstName }}</span>, <span i18n="@@doctorTriedCallingYou">our doctor tried calling you</span></h1>
    <p class="tw-font-body tw-leading-4 tw-text-200 tw-text-gray-500 tw-mb-2" i18n="@@weTriedReachingYouButCouldNotConnect">We tried reaching you but couldn't connect. To speak with the doctor, please call us at<span class="tw-text-nowrap">+91 81-500-96500.</span></p>
  </div>
</div>
<div *ngIf="!isReAcquistionRebrandingExpEnabled">
  <div class="card tw-flex tw-flex-row tw-items-center tw-gap-4 tw-rounded-2xl tw-px-5 tw-py-4 tw-mx-4 tw-bg-orange-100" (click)="handleClick()">
    <img class="tw-flex-none tw-h-20 tw-w-20 tw-rounded-full bg-black tw-bg-yellow-200" src="https://storage.googleapis.com/heallo-other-user-files/doctor_api_mahima_aggarwal_12052022_1670250785248.jpg" />
    <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
      <div>
        <p class="tw-font-body tw-font-bold tw-text-300 tw-text-black" i18n="@@missedDoctorCall">
          Missed Doctor Call
        </p>
        <p class="tw-font-body tw-text-200 tw-text-black tw-text-xs" i18n="@@iTriedCallingYouButCouldnotConnect">
          I tried calling you, but we couldn't connect.
        </p>
      </div>
      <cs-button [class]="'primary btn-xxxs btn-xxxs-padding tw-px-2 btn-float'"><cs-button-text i18n="@@takeHelp">Take help</cs-button-text><cs-icon class="tw-h-4 tw-w-4 tw-text-green-400" [iconName]="'chevron_right'"></cs-icon></cs-button>
    </div>
  </div>
</div>